import React from 'react';
import { RootGallery } from 'pages/root-gallery/root-gallery';
import { Provider } from 'react-redux';
import { SnackbarProvider, ThemeProvider } from 'fronton-react';
import { Snackbar } from 'common/components/snackbar/snackbar';
import { TStoreFromCreateStore } from 'store/create-store';

type TProps = {
  store: TStoreFromCreateStore;
};

export const GalleryEntryWidget = ({ store }: TProps) => {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <SnackbarProvider>
          <RootGallery />
          <Snackbar />
        </SnackbarProvider>
      </Provider>
    </ThemeProvider>
  );
};
